import { MetaAdReferral } from 'data/firestore/globals';
import PaidAdChip from './PaidAdChip';
import { CustomerBanner } from './styled';

interface PaidCustomerBannerProps {
    referral?: MetaAdReferral | null;
}

const PaidCustomerBanner = ({ referral }: PaidCustomerBannerProps) => {
    if (!referral) return null;

    return (
        <CustomerBanner>
            Paid customer
            <PaidAdChip referral={referral} />
        </CustomerBanner>
    );
};

export default PaidCustomerBanner;
